import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle, MapPin } from "lucide-react"; // Added MapPin
import { PopupModal } from "react-calendly";

// Reworked Hero Component
function Hero() {
  const [openBooking, setOpenBooking] = useState(false);

  return (
    <section className="relative bg-white overflow-hidden sm:pt-28 sm:pb-20">
      {" "}
      {/* Enhanced Background Image - More visible and aspirational */}
      <div className="relative sm:absolute inset-0 ">
        <picture>
          <source
            srcSet="/images/family_day_mobile.webp"
            type="image/webp"
            media="(max-width: 640px)"
          />
          <source
            srcSet="/images/family_day.webp"
            type="image/webp"
            media="(min-width: 641px)"
          />
          <img
            src="/images/family_day.webp"
            alt="Hero room"
            fetchpriority="high"
            className="w-full h-auto sm:h-full object-contain sm:object-cover opacity-100"
            width={1920}
            height={1080}
          />
        </picture>
      </div>
      {/* Overlay for text readability */}
      <div className="hidden sm:block absolute top-0 left-1/2 transform -translate-x-1/2 mt-8 text-center text-black  text-md md:text-lg font-semibold">
        Valid Until Feb 16, 2026
        <div className="hidden sm:block  block text-[#BE2026] text-2xl lg:text-2xl font-sans tracking-widest font-semibold">
          SITEWIDE
        </div>
      </div>
      <div className="container mx-auto px-4 sm:px-6 lg:px-2 relative z-10">
        <div className="sm:min-h-0 flex flex-col bg-gray-50 sm:bg-transparent justify-end sm:block">
          {/* Headline - Clearer Benefit & Scope */}
          <motion.h1
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
            className=" hidden sm:block text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 tracking-tight"
          >
            <div className="text-7xl sm:text-9xl mb-2 font-prata">
              Family Day <br />
            </div>
            <span className="font-semibold tracking-tighter text-4xl sm:text-7xl font-poppins">
              Comfort Sale
            </span>
            <div className="flex items-center justify-center sm:justify-start gap-4 mt-4">
              <div className="text-4xl sm:text-8xl lg:text-9xl font-prata text-[#BE2026] tracking-tighter scale-x-110">
                35%
              </div>
              <div className="text-xl ml-4 font-sans sm:text-2xl lg:text-5xl text-[#BE2026] font-semibold tracking-[0.1rem]">
                OFF
              </div>
            </div>
            {/* Prominent Savings */}
          </motion.h1>
          {/* Subheadline - Reinforce Key Selling Points (Customer Obsession: Address quality, origin, ease) */}
          <motion.p
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.2, ease: "easeOut" }}
            className="hidden sm:block mt-4 text-lg md:text-2xl text-gray-700 font-semibold tracking-wide leading-relaxed"
          >
            spotlight safe/ cordless options for <br />
            households with kids
          </motion.p>
          {/* CTAs - Clear Primary and Secondary Actions */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-8 mt-8">
            {/* Button Motion Div */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4, ease: "easeOut" }}
              className="hidden sm:block w-full sm:w-auto"
            >
              <Link
                to="/shop"
                className="border-2 border-primary inline-block w-full sm:w-auto bg-primary text-white px-12 py-5 rounded-lg font-semibold text-2xl text-center shadow-md hover:bg-primary/90 transition-all"
              >
                Shop Now & Save
              </Link>
            </motion.div>

            {/* Trust Badges Motion Div */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.6, ease: "easeOut" }}
              className="hidden sm:flex flex flex-col gap-3 sm:justify-end sm:absolute sm:right-0 text-xl md:text-2xl"
            >
              <div
                className="flex items-center gap-3 font-semibold text-black px-8 py-3 rounded-full"
                style={{
                  background:
                    "linear-gradient(to right, rgba(255,255,255,0.0), rgba(255,255,255,0.75) 50%, rgba(255,255,255,0.75) 20%, rgba(255,255,255,0.0))",
                  backdropFilter: "blur(2px)",
                }}
              >
                <CheckCircle className="text-[#BE2026] w-6 h-6 md:w-8 md:h-8" />
                Virtual Consult
              </div>
              <div
                className="flex items-center gap-3 font-semibold text-black px-8 py-3 rounded-full"
                style={{
                  background:
                    "linear-gradient(to right, rgba(255,255,255,0.0), rgba(255,255,255,0.75) 50%, rgba(255,255,255,0.75) 20%, rgba(255,255,255,0.0))",
                  backdropFilter: "blur(2px)",
                }}
              >
                <CheckCircle className="text-[#BE2026] w-6 h-6 md:w-8 md:h-8" />
                Free Swatches
              </div>
            </motion.div>
          </div>
        </div>
      </div>
      {/* Calendly Popup Modal */}
      <PopupModal
        url="https://calendly.com/offcutshades"
        rootElement={document.getElementById("root")}
        open={openBooking}
        onModalClose={() => setOpenBooking(false)}
        // Use default Calendly styling or pass specific props if needed
      />
    </section>
  );
}

export default Hero;
